<template lang="pug">
  .member-form
    validation-observer(v-slot="{ invalid }" ref="member")
      a.preview.member(v-if="!(editMember || invalid)" href="#" @click.prevent.stop="edit = true")
        .icon
          svg.default-icon(
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          )
            path(
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.3"
              d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            )
          edit-icon
        .data
          .field-preview
            .label Name
            .field-value {{ firstName }} {{ lastName }}
          .field-preview(v-if="email")
            .label E-Mail Adresse
            .field-value {{ email }}
          .field-preview(v-if="mobile")
            .label Mobilnummer
            .field-value {{ mobile }}
      .form-fields(v-show="editMember || invalid")
        .trible-field
          .field(:style="{ 'max-width': '120px' }")
            fieldset.form-field
              label.label Anrede
              multiselect(
                v-model="gender"
                :options="genders"
                :multiple="false"
                :searchable="false"
                :allow-empty="true"
                :show-labels="true"
                track-by="value"
                label="label"
                :placeholder="salutation"
                deselect-label=""
                selected-label=""
                select-label=""
              )
          .field
            fieldset.form-field
              validation-provider(name="Vorname" rules="required" v-slot="{ errors }")
                label.label(for="first_name") Vorname
                .control.has-icons-right
                  input#first_name.input(
                    type="text"
                    name="first_name"
                    v-model="firstName"
                    :class="{ 'is-danger': errors && errors.length }"
                  )
                  span.icon
                    font-awesome-icon(icon="user")
                p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                p.help.has-text-grey(v-else) Pflichtfeld
          .field
            fieldset.form-field
              validation-provider(name="Nachname" rules="required" v-slot="{ errors }")
                label.label(for="last_name") Nachname
                .control.has-icons-right
                  input#last_name.input(
                    type="text"
                    name="last_name"
                    v-model="lastName"
                    :class="{ 'is-danger': errors && errors.length }"
                  )
                  span.icon
                    font-awesome-icon(icon="user")
                p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                p.help.has-text-grey(v-else) Pflichtfeld
        //- .form-field
        //-   label.label(for="company") Firma
        //-   .control.has-icons-right
        //-     input#company.input(type="text" name="company" v-model="company")
        //-     span.icon
        //-       font-awesome-icon(icon="city")
        .double-field
          .field
            fieldset.form-field
              validation-provider(
                name="E-Mail Adresse"
                :rules="emailRules"
                v-slot="{ errors }"
              )
                label.label(for="email") E-Mail Adresse
                .control.has-icons-right
                  input#email.input(
                    type="email"
                    name="email"
                    v-model="email"
                    :class="{ 'is-danger': errors && errors.length }"
                  )
                  span.icon
                    font-awesome-icon(icon="at")
                p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                p.help.has-text-grey(v-else) Pflichtfeld
          .field
            fieldset.form-field
              label.label(for="mobile") Mobilnummer
              .control.has-icons-right
                input#mobile.input(
                  type="tel"
                  name="mobile"
                  v-model="mobile"
                )
                span.icon
                  font-awesome-icon(icon="phone")
        template(v-if="! isAuthenticated")
          fieldset.form-field
            p-check(
              name="create_account"
              color="dark"
              v-model="createAccount"
            )
              | Account erstellen
          transition(name="slide-fade-down" :duration="350")
            fieldset.form-field(v-if="createAccount")
              validation-provider(name="Passwort" rules="required|zxcvbn:3" v-slot="{ errors }")
                label.label(for="password") Passwort
                .control.has-icons-right
                  input#password.input(
                    :type="password.type"
                    name="password"
                    v-model="accountPassword"
                    :class="{ 'is-danger': errors && errors.length }"
                  )
                  button.icon(
                    v-if="accountPassword && password.type === 'password'"
                    type="button" @click="password.type = 'text'"
                  )
                    font-awesome-icon(icon="eye")
                  button.icon(
                    v-else-if="accountPassword && password.type === 'text'"
                    type="button" @click="password.type = 'password'"
                  )
                    font-awesome-icon(icon="eye-slash")
                  span.icon(v-else)
                    font-awesome-icon(icon="key")
                PasswordStrengthMeter(
                  :password="accountPassword"
                  @score="score => password.score = score"
                  @feedback="passwordFeedback"
                )
                p.help.is-danger(v-if="password.warning || (errors && errors.length)") {{ password.warning || errors[0] }}
                p.help.has-text-grey(v-else) Pflichtfeld

</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import Multiselect from 'vue-multiselect';

import EditIcon from '@/extensions/restricted-area/components/UserForm/Partials/EditIcon';
import PasswordStrengthMeter from '@/components/PasswordStrengthMeter';

import { translateWarnings } from '@/extensions/restricted-area/helpers/validate';

export default {
  name: 'MemberForm',
  props: {
    // form: {
    //   type: Object,
    //   required: true
    // }
  },
  data: () => ({
    // flag to show the form fields
    // only if the corresponding part is valid
    // and (this.isAuthenticated && this.form.id)
    edit: false,

    genders: [
      {
        value: 'M',
        label: 'Herr'
      },
      {
        value: 'F',
        label: 'Frau'
      },
      {
        value: 'X',
        label: 'Sonstiges'
      }
    ],
    password: {
      type: 'password',
      score: 0,
      warning: false,
      success: false,
      suggestions: []
    }
  }),
  components: {
    EditIcon,
    ValidationProvider,
    ValidationObserver,
    PasswordStrengthMeter,
    Multiselect
  },
  computed: {
    salutation() {
      let salutation = '';
      if (this.member.gender === 'M') salutation = 'Herr';
      else if (this.member.gender === 'F') salutation = 'Frau';
      return salutation;
    },
    firstName: {
      get() {
        return this.checkout.form.account.first_name;
      },
      set(value) {
        this.setField({ field: 'first_name', value });
      }
    },
    lastName: {
      get() {
        return this.checkout.form.account.last_name;
      },
      set(value) {
        this.setField({ field: 'last_name', value });
      }
    },
    email: {
      get() {
        return this.checkout.form.account.email;
      },
      set(value) {
        this.setField({ field: 'email', value });
      }
    },
    phone: {
      get() {
        return this.checkout.form.account.phone;
      },
      set(value) {
        this.setField({ field: 'phone', value });
      }
    },
    mobile: {
      get() {
        return this.checkout.form.account.mobile;
      },
      set(value) {
        this.setField({ field: 'mobile', value });
      }
    },
    company: {
      get() {
        return this.checkout.form.account.company;
      },
      set(value) {
        this.setField({ field: 'company', value });
      }
    },
    createAccount: {
      get() {
        return this.checkout.form.account.create;
      },
      set(value) {
        this.setField({ field: 'create', value });
      }
    },
    accountPassword: {
      get() {
        return this.checkout.form.account.password;
      },
      set(value) {
        this.setField({ field: 'password', value });
      }
    },
    gender: {
      get() {
        return this.genders.find(el => el.value === this.checkout.form.account.gender);
      },
      set(gender) {
        this.setField({ field: 'gender', value: gender.value });
      }
    },
    emailRules() {
      let rules = ['required', 'email'];
      if (this.createAccount) rules.push('unique-email');
      return rules.join('|');
    },
    editMember() {
      return !this.isAuthenticated || !this.checkout.form.account.id || this.edit;
    },
    ...mapGetters({
      member: 'auth/member',
      isAuthenticated: 'auth/isAuthenticated',
      checkout: 'shop/checkout'
    })
  },
  methods: {
    passwordFeedback(feedback) {
      // translateSuggestion
      this.password.warning = translateWarnings(feedback.warning);
    },
    ...mapMutations({
      setField: 'shop/setCheckoutFormAccountField'
    })
  }
};
</script>
